import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkdownIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_612_8974)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M28.25 7.75H11.75C11.3522 7.75 10.9706 7.90804 10.6893 8.18934C10.408 8.47064 10.25 8.85218 10.25 9.25V22.75C10.25 23.1478 10.408 23.5294 10.6893 23.8107C10.9706 24.092 11.3522 24.25 11.75 24.25H28.25C28.6478 24.25 29.0294 24.092 29.3107 23.8107C29.592 23.5294 29.75 23.1478 29.75 22.75V9.25C29.75 8.85218 29.592 8.47064 29.3107 8.18934C29.0294 7.90804 28.6478 7.75 28.25 7.75ZM28.25 9.25V12.25H11.75V9.25H28.25Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_612_8974",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgMarkdownIcon;
